import { Mail } from "lucide-react";
import { toWaNumber } from "./WhatsAppLink";
import { openWhatsApp } from "../lib/waLink";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.43 9.43 0 0 1-1.45-5.03c0-5.2 4.24-9.44 9.45-9.44a9.38 9.38 0 0 1 6.68 2.77 9.38 9.38 0 0 1 2.76 6.68c0 5.21-4.24 9.44-9.45 9.44zm8.04-17.48A11.3 11.3 0 0 0 12.05.69C5.78.69.68 5.79.68 12.06c0 2 .52 3.96 1.52 5.68L.58 23.69l6.1-1.6a11.36 11.36 0 0 0 5.37 1.37h.01c6.27 0 11.37-5.1 11.37-11.37 0-3.04-1.18-5.89-3.34-8.04z" />
  </svg>
);

export const ContactChannels = ({ email, whatsapp, cellulare, id }) => {
  if (!email && !whatsapp) return null;
  const wa = toWaNumber(cellulare);
  const openWa = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (wa) openWhatsApp(wa);
  };
  return (
    <div className="flex items-center gap-1.5 mt-1" data-testid={`thread-channels-${id}`}>
      {email && <span title="Email registrata" data-testid={`thread-channel-email-${id}`}><Mail className="h-3.5 w-3.5 text-sky-500" /></span>}
      {whatsapp && (
        <span role="button" tabIndex={0} onClick={openWa} onKeyDown={(e) => { if (e.key === "Enter") openWa(e); }}
          title={`Scrivi su WhatsApp (+${wa})`} aria-label="Apri WhatsApp" data-testid={`thread-channel-whatsapp-${id}`}
          className="inline-flex cursor-pointer text-green-500 hover:text-green-600 hover:scale-110 transition-transform">
          <WhatsAppIcon className="h-3.5 w-3.5" />
        </span>
      )}
    </div>
  );
};

export const UnreadBadge = ({ count, id }) =>
  count > 0 ? (
    <span className="ml-auto min-w-[20px] text-center text-[10px] font-mono font-semibold bg-amber-500 text-[#0a0d14] rounded-full px-1.5 py-0.5"
      title="Messaggi non letti" data-testid={`thread-unread-${id}`}>{count}</span>
  ) : null;
